import { useState } from 'react';

import { navSections } from './DesktopSidebar.config';
import { DesktopSidebarOrganization } from './DesktopSidebarOrganization';
import { SidebarSectionBlock } from './DesktopSidebarNav';
import type { SidebarGroup } from './DesktopSidebar.types';
import { useNavFitScale } from './useNavFitScale';

const ORGANIZATION_TITLE = 'КОМПАНИЯ';

type DesktopSidebarMenuProps = {
  groups: SidebarGroup[];
  groupsLoading: boolean;
  otdelsOpen: boolean;
  selectedGroupId: string | null;
  selectedGroupName: string;
  onNavigate: (to: string) => void;
  onOtdelsOpenChange: (open: boolean) => void;
};

export function DesktopSidebarMenu({
  groups,
  groupsLoading,
  otdelsOpen,
  selectedGroupId,
  selectedGroupName,
  onNavigate,
  onOtdelsOpenChange,
}: DesktopSidebarMenuProps) {
  const [openSections, setOpenSections] = useState<Set<string>>(() => {
    const initial = new Set<string>();
    navSections.forEach((s) => initial.add(s.title));
    initial.add(ORGANIZATION_TITLE);
    return initial;
  });

  const toggleSection = (title: string) => {
    setOpenSections((prev) => {
      const next = new Set(prev);
      if (next.has(title)) {
        next.delete(title);
      } else {
        next.add(title);
      }
      return next;
    });
  };

  const [workSection, ...restSections] = navSections;

  const { navRef, contentRef } = useNavFitScale();

  return (
    <nav ref={navRef} className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div
        ref={contentRef}
        className="flex flex-col gap-[calc(2px*var(--nav-scale,1))] px-3"
      >
        <SidebarSectionBlock
          section={workSection}
          open={openSections.has(workSection.title)}
          onToggle={() => toggleSection(workSection.title)}
        />

        <DesktopSidebarOrganization
          groups={groups}
          groupsLoading={groupsLoading}
          accordionOpen={openSections.has(ORGANIZATION_TITLE)}
          otdelsOpen={otdelsOpen}
          selectedGroupId={selectedGroupId}
          selectedGroupName={selectedGroupName}
          onNavigate={onNavigate}
          onAccordionToggle={() => toggleSection(ORGANIZATION_TITLE)}
          onOtdelsOpenChange={onOtdelsOpenChange}
        />

        {restSections.map((section) => (
          <SidebarSectionBlock
            key={section.title}
            section={section}
            open={openSections.has(section.title)}
            onToggle={() => toggleSection(section.title)}
          />
        ))}
      </div>
    </nav>
  );
}
